<script lang="ts">
import { defineComponent, h } from "vue";

// ENG-21320 native QTabPanel replacement; explicit `name` keeps MTab in the parent-chain (task-list.vue parentNames check).
export default defineComponent({
  name: "MTab",
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  setup(_, { slots }) {
    return () =>
      h(
        "div",
        {
          class: "m-tab",
        },
        slots.default?.() ?? [],
      );
  },
});
</script>
